import { MaintenanceNotice } from "@/components/maintenance";
import { FallbackThemeProvider } from "@/ui";

import { RouteErrorBoundary } from "./RouteErrorBoundary";

/**
 * Catches errors thrown above the dashboard's own route boundary (providers, auth
 * guards, splash gates). Such an error unmounts `Providers`, and with it the theme
 * and the maintenance notice, so this fallback brings its own theme and renders
 * the notice again: a crash during a backend outage still says why.
 */
export const RootErrorBoundary = () => (
  <FallbackThemeProvider>
    <RouteErrorBoundary />
    <MaintenanceNotice />
  </FallbackThemeProvider>
);
